var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.top_banner }, [
    _c(
      "div",
      {
        class: _vm.$style.banner,
        style: {
          backgroundImage:
            "url(https://cdn.ganttpro.com/app/imgs/pricing/BF_top_banner.png)",
        },
      },
      [
        _c("div", { class: _vm.$style.wrapper }, [
          _c("div", { class: _vm.$style.left_side }, [
            _vm._v("\n        Black Weeks\n      "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.right_side },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.locales("bf_top_banner_description")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("chip", {
                attrs: {
                  readonly: true,
                  bold: true,
                  styles: { fontSize: "16px", lineHeight: "24px" },
                  text: _vm.locales("bf_banner_period"),
                },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }